export default {
    baseStyle: {
        container: {
            minHeight: 4,
            fontSize: 'sm',
            textAlign: 'left',
            w: 'full',
            p: ['3px 10px', null, '3px 20px'],
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: 'borderGray',
            backgroundColor: 'white'
        },
        list: {
            overflowX: ['auto', null, null, 'initial'],
            whiteSpace: ['nowrap', null, null, 'normal']
        },
        separator: {
            color: 'darkGray'
        },
        link: {
            paddingTop: 3,
            paddingBottom: 3,
            color: 'darkGray',
            fontSize: 'md'
        },
        lastitem: {
            color: 'fullBlack'
        }
    },
    variants: {
        transparentDark: {
            container: {
                borderTopWidth: 0,
                borderBottomWidth: 0,
                backgroundColor: 'transparent',
                position: 'absolute',
                top: ['64px', null, '52px'],
                zIndex: 1
            }
        },
        transparentLight: {
            container: {
                borderTopWidth: 0,
                borderBottomWidth: 0,
                backgroundColor: 'transparent',
                position: 'absolute',
                top: ['64px', null, '52px'],
                zIndex: 1
            },
            separator: {
                color: 'white'
            },
            link: {
                color: 'white'
            },
            lastitem: {
                color: 'white'
            }
        }
    },
    parts: ['container', 'separator', 'link', 'lastitem']
}
